import { useTypedQuery } from "hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useExportsQuery = () =>
  useTypedQuery({
    queryKey: FactoryExportsDashboardQueryKeys.exports,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.exports
  });
